import * as React from 'react'
import { Link } from 'react-navi';

import './modal.scss'
import { Voting, ModalState } from '../voting/voting';
import { GlobalEnv, Env } from '../../../utils/env';

import closeImg from "../../../images/close.png"

const divStyle = {
    display: 'none'
}

interface IProp { }

interface IState {
    show: boolean
    optionName: string
    content: string
    voteSum: number
    remaining: boolean
    nextURL: string,
    shopURL: string,

    voteId: string
    optionId: string
    callback: Fn;
}
class StartModal extends React.Component<IProp, IState> {
    public state = {
        show: false,
        optionName: '',
        content: '',
        voteSum: 0,
        remaining: true,
        nextURL: '',
        shopURL: '',

        voteId: '',
        optionId: '',
        callback: (...res: any[]) => { /** null */ }
    }
    private subscrib = modalPS;


    constructor(props: IProp) {
        super(props);
        this.subscrib.bind((voteid: string, option: string, callback: Fn) => {
            this.setState({
                voteId: voteid,
                optionId: option,
                callback: callback
            }, () => {
                this.setState({
                    show: true
                })
            })
        })
    }
    public closeStartModal() {
        this.setState({
            show: false
        })
    }
    public closeSuccessModal() {
        this.setState({
            show: false,
            remaining: true,
        })
    }

    public onchange(res: any, state: ModalState) {
        if (res.options && res.options.length === 1) {
            this.state.callback(res, state)
            const option = res.options[0];
            this.setState({
                optionName: option.name,
                content: option.description,
                voteSum: option.vote_num,
                nextURL: res.redirect_url,
                shopURL: GlobalEnv === Env.App ? option.app_url : option.shop_url
            }, () => {
                setTimeout(() => {
                    this.setState({
                        remaining: !((res.max_num - res.voted_num) <= 0 && state === ModalState.Voting)
                    })
                }, 1000)
            })
        }
    }

    public moreInfo() {
        if (this.state.nextURL) {
            window.location.href = this.state.nextURL
        } else {
            this.closeSuccessModal()
        }
    }

    public render() {
        return (
            <div className="start-modal" style={this.state.show ? {} : divStyle}>
                <div className="modal-start" style={this.state.remaining ? {} : divStyle}>
                    <img className="close-btn" src={closeImg} alt="" onClick={() => { this.closeStartModal() }} />
                    <div className="company-name overhide">{this.state.optionName}</div>
                    <div className="company-info clearfix">
                        <span className="info-content overhide">{this.state.content}</span>
                        {this.state.content && <Link href={`/detail/${this.state.voteId}/info/${this.state.optionId}`} onClick={() => { this.closeStartModal() }}>
                            <span className="info-detail">详细</span>
                        </Link>}
                    </div>
                    <Voting
                        NECaptchaKey="common-modal"
                        voteID={this.state.voteId}
                        optionID={this.state.optionId}
                        moreUrl={this.state.nextURL}
                        shopUrl={this.state.shopURL}
                        success={(res, state) => { this.onchange(res, state) }}
                    />
                </div>
                <div className="modal-after" style={this.state.remaining ? divStyle : {}}>
                    <img className="close-btn" src={closeImg} alt="" onClick={() => { this.closeSuccessModal() }} />
                    <div className="vote-suc">投票成功</div>
                    <div className="has-vote">当前票数&nbsp;{this.state.voteSum}</div>
                    <div className="watch-more" onClick={() => { this.moreInfo() }}>查看更多精彩</div>
                    <a style={this.state.shopURL ? {} : divStyle} href={this.state.shopURL} className="turn-shop">进入企点店铺了解更多</a>
                </div>
            </div>
        )
    }
}


// 简单的订阅者，只有一个订阅者
type Fn = (...arg: any[]) => void;
class Publish {
    private store: { [key: string]: Fn } = {}
    public subscrib(key: string, fn: Fn) {
        this.store[key] = fn;
    }
    public publish(key: string, ...value: any[]) {
        this.store[key] && this.store[key](...value);
    }
}

interface IModalData {
    VoteID: string,
    OptionID: string,
    Callback: (...res: any[]) => void
}

class ModalMsg extends Publish {
    private key = "open"
    public bind(fn: Fn) {
        this.subscrib(this.key, fn)
    }
    public show(data: IModalData) {
        this.publish(this.key, data.VoteID, data.OptionID, data.Callback)
    }
}

const modalPS = new ModalMsg()


export {
    StartModal,
    modalPS
}


// WEBPACK FOOTER //
// ./src/components/common/modal/modal.tsx